var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlexibleTrading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 82,
    viewBox: "0 0 89 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80444 79.0718C57.5274 79.0718 78.8392 79.0718 83.0297 79.0718",
    stroke: "#302F3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.988,
    y: 36.4824,
    width: 12.5716,
    height: 38.9638,
    rx: 2,
    fill: "url(#paint0_linear_79_1084)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.988,
    y: 36.4824,
    width: 12.5716,
    height: 38.9638,
    rx: 2,
    stroke: "#302F3A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0498,
    y: 25.6099,
    width: 12.5716,
    height: 49.8375,
    rx: 2,
    fill: "url(#paint1_linear_79_1084)",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0498,
    y: 25.6099,
    width: 12.5716,
    height: 49.8375,
    rx: 2,
    stroke: "#AAECD8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1123,
    y: 36.4824,
    width: 12.5716,
    height: 38.9638,
    rx: 2,
    fill: "url(#paint2_linear_79_1084)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1123,
    y: 36.4824,
    width: 12.5716,
    height: 38.9638,
    rx: 2,
    stroke: "#302F3A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 64.1719,
    y: 43.7314,
    width: 12.5716,
    height: 31.7148,
    rx: 2,
    fill: "url(#paint3_linear_79_1084)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 64.1719,
    y: 43.7314,
    width: 12.5716,
    height: 31.7148,
    rx: 2,
    stroke: "#302F3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0896 24.1817L34.3455 7.778C34.7367 7.3832 35.3748 7.3832 35.7661 7.778L52.4722 24.6361C52.8671 25.0346 53.5125 25.0303 53.9021 24.6265L74.8385 2.92871M74.8385 2.92871H68.403M74.8385 2.92871V8.83232",
    stroke: "url(#paint4_linear_79_1084)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_1084",
    x1: 12.988,
    y1: 36.4824,
    x2: 32.3898,
    y2: 40.2472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_1084",
    x1: 36.3356,
    y1: 28.1017,
    x2: 36.3356,
    y2: 75.4473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_79_1084",
    x1: 47.1123,
    y1: 36.4824,
    x2: 66.5141,
    y2: 40.2472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_79_1084",
    x1: 64.1719,
    y1: 43.7314,
    x2: 83.2215,
    y2: 48.2728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_79_1084",
    x1: 74.9475,
    y1: 4.31535,
    x2: 14.6951,
    y2: 22.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibleTrading);
export default __webpack_public_path__ + "static/media/FlexibleTrading.f3a93998e6bbd314902f02314f33062f.svg";
export { ForwardRef as ReactComponent };